// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"376":"823a2f93","613":"822318ab"}[chunkId] + ".chunk.css";
};